'use client'

import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import type { PrivacyPolicyConfiguration } from 'legal/types/featureFlag'

import type { PRIVACY_POLICY_CONFIGURATIONS } from '../../../constants/privacyPolicyConfiguration'
import { privacyPolicyVariationsBase } from '../privacyPolicyVariationsBase'

export const usePrivacyPolicyVariations = (
	isInCheckout = false
): PRIVACY_POLICY_CONFIGURATIONS => {
	const privacyPolicyConfiguration = useFeatureFlag<PrivacyPolicyConfiguration>(
		featureFlagKeys.PrivacyPolicyConfiguration
	)

	return privacyPolicyVariationsBase({
		isInCheckout,
		privacyPolicyConfiguration,
	})
}
